var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-modal-base',{attrs:{"onClose":_vm.onClose}},_vm._l((_vm.texts),function(text,index){return _c('p',{key:index,staticClass:"text"},[_vm._v(" "+_vm._s(text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }